import { styled } from '@mui/material/styles';
import { Box, Typography, Button, TextField } from '@mui/material';

export const EmployeeSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1.5),
}));

export const EmployeeAvatar = styled(Box)({
  marginBottom: '8px',
});

export const EmployeeName = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

export const EmployeeRoles = styled(Typography)(({ theme }) => ({
  color: theme.colors.gray,
  textAlign: 'center',
}));

export const SectionLabel = styled(Typography)(({ theme }) => ({
  color: theme.colors.gray,
  fontWeight: 600,
  letterSpacing: '0.05em',
  marginBottom: theme.spacing(1.5),
  fontSize: '0.75rem',
}));

export const PaymentMethodSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const PaymentMethodList = styled(Box)(({ theme }) => ({
  background: theme.palette.primary.main,
  borderRadius: '12px',
  overflow: 'hidden',
}));

export const PaymentMethodOption = styled(Box)(({ theme, selected, disabled, isLast }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(1.75, 2),
  borderBottom: isLast ? 'none' : `1px solid ${theme.palette.divider}`,
  cursor: disabled ? 'not-allowed' : 'pointer',
  transition: 'background-color 0.2s ease',
  opacity: disabled ? 0.6 : 1,
  backgroundColor: selected ? theme.palette.background.secondaryHover : 'transparent',
  outline: 'none',

  '&:hover': {
    backgroundColor: disabled ? 'transparent' : theme.palette.background.secondaryHover,
  },

  '&:focus-visible': {
    backgroundColor: theme.palette.background.secondaryHover,
    outline: `2px solid ${theme.palette.primary.light}`,
    outlineOffset: '-2px',
  },
}));

export const PaymentDetailsSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const PaymentDetailsList = styled(Box)(({ theme }) => ({
  background: theme.palette.primary.main,
  borderRadius: '12px',
  overflow: 'hidden',
}));

export const DetailRow = styled(Box)(({ theme, isLast }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(1.75, 2),
  borderBottom: isLast ? 'none' : `1px solid ${theme.palette.divider}`,
}));

export const AmountInputContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(1.75, 2),
  gap: theme.spacing(2),
}));

export const AmountInput = styled(TextField)(({ theme }) => ({
  flex: '0 0 auto',
  width: 'auto',
  '& .MuiInputBase-root': {
    fontSize: '17px', // h6 font size
    fontWeight: 500, // h6 font weight
    lineHeight: '22px', // h6 line height
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '8px',
    padding: theme.spacing(1, 1.5),
  },
  '& .MuiInputAdornment-root': {
    marginRight: 0,
    marginLeft: 0,
  },
  '& .MuiInputBase-input': {
    padding: 0,
    width: '60px',
    textAlign: 'right',
    color: theme.palette.text.secondary,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  marginTop: theme.spacing(0.5),
  fontSize: '0.75rem',
}));

export const DateValue = styled(Typography)(({ theme }) => ({
  color: theme.colors.gray,
}));

export const ErrorContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

export const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  marginTop: 'auto',
  padding: theme.spacing(1.5),
  fontSize: '1rem',
  fontWeight: 600,
  textTransform: 'none',
  borderRadius: theme.spacing(2),
  backgroundColor: theme.colors.blue,
  color: theme.colors.white,

  '&:hover': {
    backgroundColor: theme.palette.text.secondaryHover,
  },

  '&:disabled': {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
  },
}));
